module.exports = __webpack_public_path__ + "static/media/pathfinder-logo.08b7fc66.png";